import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';

@Injectable({ providedIn: 'root' })
export class ApiDataTravelMemberAllergyService {
  constructor(private _api: ApiService) {}

  get(id: number | string) {
    return this._api.get('data-travel-member-allergy/get/id/' + id);
  }

  list(data: any = {}) {
    return this._api.post('data-travel-member-allergy/list', data);
  }

  create(data: any) {
    return this._api.post('data-travel-member-allergy/create', data);
  }

  update(data: any) {
    return this._api.post('data-travel-member-allergy/update', data);
  }

  remove(id: number) {
    return this._api.post('data-travel-member-allergy/remove/id/' + id);
  }
}
